import { Component, computed, inject } from '@angular/core';
import { BuildingScanService, BuildingScanShareLinkService } from '@artemis-software/wr-api';
import { routeParam } from '@/utils/signals/router';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { loader } from '@/utils/signals/loader';
import { firstValueFrom } from 'rxjs';
import { DialogService } from '@services/dialog-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'wr-building-point-cloud-scan-page',
  templateUrl: './building-point-cloud-scan-page.component.html',
  styleUrls: ['./building-point-cloud-scan-page.component.scss'],
})
export class BuildingPointCloudScanPageComponent {
  readonly buildingScanService = inject(BuildingScanService);
  readonly shareLinkService = inject(BuildingScanShareLinkService);
  readonly dialogService = inject(DialogService);
  readonly sanitizer = inject(DomSanitizer);

  readonly scanId = routeParam('scanId', true);

  readonly loading = loader();

  readonly buildingScan = asyncComputed(() => this.buildingScanService.getBuildingScanById(this.scanId()), undefined, this.loading);

  readonly buildingScanLink = computed<SafeResourceUrl | null>(() => {
    const scan = this.buildingScan();
    if (!scan?.pointCloudId) {
      return null;
    }

    const url = `https://benaco.com/embed/${scan.pointCloudId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  });

  async navigateBack(): Promise<void> {
    window.history.back();
  }

  async deleteScan() {
    if (await this.dialogService.showDeleteDialog(
      'Scan löschen',
      'Bist du sicher, dass du diesen Scan löschen willst?',
    )) {
      await firstValueFrom(this.buildingScanService.deleteBuildingScan(this.scanId()));
      await this.navigateBack();
    }
  }

  createShareLink() {
    const buildingScan = this.buildingScan();
    if (!buildingScan)
      return;

    this.dialogService.showShareLinkDialog({
      createShareLink: (options) => this.shareLinkService.createShareLink({
        id: buildingScan!.id,
        duration: options.durationDays
      })
    });
  }

}
